<template>
    <div class="feed">
        <div class="row">
            <div class="col-md-4 feed-item" v-for="item in feed" :key="item.id" :class="itemClass(item)" @click="toggle(item)">
                <h5>{{ item.title }}</h5>
                <img :src="item.image" />
            </div>
        </div>
    </div>
</template>
<script>
    import FeedMixin from './FeedMixin';
    export default {
        name: 'YoutubeFeed',
        mixins: [FeedMixin]
    }
</script>